import React, { Component } from 'react';
import { NumberInput } from '../components/NumberInput.tsx';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { TermSelect } from '../components/TermSelect.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { LenderRow } from '../components/LenderRow';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    updateLead(props:any):void;
    remainingTerm?: number;
    monthlyRepayments?: number;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    remainingTerm?: number;
    monthlyRepayments?: number;
}

export class CurrentlyPaying extends Component<IProps, IState> {

    constructor (props: IProps) {
        super(props);
        this.state = {hasError: false, remainingTerm: this.props.remainingTerm ?? 25, monthlyRepayments: this.props.monthlyRepayments};
    }

    componentDidMount(): void {
        this.props.gtmEvent();
        if (!this.props.remainingTerm)
            this.props.updateLead({remainingTerm:25});
    }

    nextStep() {
        if (!this.state.remainingTerm || !this.state.monthlyRepayments) {
            var errors:string[]=[];
            if (!this.state.remainingTerm) {
                errors.push("Remaining term is required");
            }
            if (!this.state.monthlyRepayments) {
                errors.push("Monthly mortgage repayments is required");
            }
            this.setState({errors: errors, hasError: true});
            return;
        }
        this.props.nextStep();
    }

    render() {

        return (
            <header className="App-header">
                <h1 className='l'><span className='doddltext'>Thanks,</span> and what are you<br/>currently paying?</h1>
                <div className='wrapper'>
                    <div className='row'>
                        <div className='column2 justify-e'>
                            <TermSelect 
                                label={<><strong>Remaining term</strong> on your mortgage</>}
                                selectedterm={this.props.remainingTerm}
                                classes={this.state.hasError && !this.state.remainingTerm ? "e" : ""}
                                onChange={(e) => { this.setState({remainingTerm: +e.target.value}); this.props.updateLead({remainingTerm:+e.target.value}); }} />
                        </div>
                        <div className='column2 justify-s'>
                            <NumberInput
                                id='monthlyrepayments'
                                key='monthlyrepayments'
                                label={<>Monthly mortgage <strong>repayments</strong></>}
                                value={this.props.monthlyRepayments}
                                classes={this.state.hasError && !this.state.monthlyRepayments ? "e" : ""}
                                onChange={(e) => { this.setState({monthlyRepayments: e.target.value}); this.props.updateLead({monthlyRepayments:e.target.value}); }} />
                        </div>
                    </div>
                    {this.state.hasError &&
                        <ErrorBox errors={this.state.errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton onClick={() => this.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>

                </div>
            </header>
        );
    }
}
